import { AppointmentDialog } from "@/components/appointments/AppointmentDialog";
import { useAppointmentDraft } from "@/contexts/AppointmentDraftContext";
import { useGoogleCalendarStatus } from "@/hooks/useGoogleCalendarStatus";
import { useWorkspace } from "@/hooks/useWorkspace";
import { useAuth } from "@/hooks/useAuth";

/**
 * Mantém o dialog de agendamento montado no layout — sobrevive à navegação
 * enquanto o rascunho estiver aberto ou minimizado.
 */
export function AppointmentDraftHost() {
  const { user } = useAuth();
  const { workspaceId } = useWorkspace(user?.id);
  const { session, minimized, setMinimized, closeDraft, isActive } = useAppointmentDraft();
  const { hasConnection: hasGoogleCalendar, isChecking: gcalIsChecking } =
    useGoogleCalendarStatus();

  if (!isActive || !session || !workspaceId) return null;

  return (
    <AppointmentDialog
      key={session.key}
      open
      minimized={minimized}
      onMinimizedChange={setMinimized}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && minimized) return;
        if (!nextOpen) closeDraft();
      }}
      workspaceId={workspaceId}
      initialDate={session.initialDate}
      initialHour={session.initialHour}
      initialLeadId={session.initialLeadId}
      conversationId={session.conversationId}
      hasGoogleCalendar={hasGoogleCalendar}
      isCheckingCalendarStatus={gcalIsChecking}
      rescheduleContext={session.rescheduleContext}
      onSuccess={() => {
        session.onSuccess?.();
        closeDraft();
      }}
    />
  );
}
